import { escapeHtml } from '../utils/html'

export function infoTooltipTemplate(
	id: string,
	label: string,
	text: string,
): string {
	return `<span class="info-tooltip" data-info-tooltip><button type="button" class="info-tooltip-button" aria-label="${escapeHtml(label)}" aria-describedby="${escapeHtml(id)}"><svg aria-hidden="true"><use href="#symbols-info-circle"></use></svg></button><span id="${escapeHtml(id)}" class="info-tooltip-text" role="tooltip" hidden>${escapeHtml(text)}</span></span>`
}
